import { render, staticRenderFns } from "./History.vue?vue&type=template&id=779751bc&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/order.css?vue&type=style&index=0&id=779751bc&prod&scoped=true&lang=css&external"
import style1 from "./History.vue?vue&type=style&index=1&id=779751bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779751bc",
  null
  
)

export default component.exports